// Turn a markdown body into a meta description. Course lessons have no
// description column of their own (articles do), so the one that reaches Google
// has to be derived from the prose. Anything that reads as markup rather than a
// sentence is dropped: a description that opens with "```ts" or "## Overview"
// is worse than none.
const MAX = 155

export function excerpt(markdown: string | null | undefined, max = MAX): string {
  if (!markdown) return ''
  const text = markdown
    .replace(/^---\n[\s\S]*?\n---\n/, '') // frontmatter
    .replace(/```[\s\S]*?```/g, ' ') // fenced code and mermaid blocks
    .replace(/<[^>]+>/g, ' ') // inline html
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ') // images
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1') // links keep their text
    .replace(/^\s{0,3}#{1,6}\s+.*$/gm, ' ') // headings
    .replace(/^\s{0,3}>\s?/gm, '') // blockquote markers
    .replace(/^\s{0,3}([*+-]|\d+\.)\s+/gm, '') // list markers
    .replace(/[*_`~]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
  if (text.length <= max) return text
  // Cut on a word boundary rather than mid-word, and drop a trailing comma or
  // similar so the ellipsis doesn't read as a typo.
  const cut = text.slice(0, max)
  const at = cut.lastIndexOf(' ')
  return `${(at > max * 0.6 ? cut.slice(0, at) : cut).replace(/[\s,;:.]+$/, '')}…`
}
